<!--
  Un mensaje: icono del tipo, el texto (con su prefijo solo para lectores de pantalla) y el enlace si lo hay; a la
  derecha, cerrar. Abajo, la barra del tiempo que queda. La región viva (role y aria-live) la lleva el anfitrión desde
  que se crea; el texto llega al activarse.
-->
<div class="cc-flotante__caja" [class]="'is-' + tipo + ' is-' + estado" [class.is-pausado]="pausado"
     (mouseenter)="pausa()" (mouseleave)="reanuda()" (focusin)="pausa()" (focusout)="alSalirFoco($event)" (keydown.escape)="cierra()">
  <span class="cc-flotante__icono" aria-hidden="true"><span class="material-icons">{{ icono }}</span></span>
  <div class="cc-flotante__cuerpo">
    @if (conTexto) {
      <p class="cc-flotante__texto"><span class="cc-flotante__oculto">{{ prefijo }} </span>{{ mensaje }}</p>
      @if (accion) {
        <button type="button" class="cc-flotante__accion" (click)="sigue()">
          {{ accion.texto }}
          <span class="material-icons" aria-hidden="true">arrow_forward</span>
        </button>
      }
    }
  </div>
  <button type="button" class="cc-flotante__cerrar" title="Cerrar" aria-label="Cerrar el mensaje" (click)="cierra()">
    <span class="material-icons" aria-hidden="true">close</span>
  </button>
  <span class="cc-flotante__tiempo" aria-hidden="true"><span [style.animation-duration.ms]="duracion"></span></span>
</div>
